import { Link } from 'react-router-dom'
import { Zap, ArrowRight } from 'lucide-react'

// The only public page at bare "/" — everything else still requires login (see App.tsx's
// RootGate). Anonymous visitors land here; logged-in users never see it (RootGate redirects
// straight past it).
export function LandingPage() {
  return (
    <div className="min-h-screen bg-paper flex flex-col">
      <header className="h-14 flex items-center px-6">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-[#0f1117] flex items-center justify-center">
            <div className="w-[18px] h-[18px] rounded bg-accent flex items-center justify-center">
              <span className="text-white text-[8px] font-bold leading-none">R</span>
            </div>
          </div>
          <span className="text-ink font-semibold text-lg tracking-tight">Rabbit</span>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-lg text-center">
          <h1 className="text-2xl font-semibold text-ink mb-3">Rabbit Console</h1>
          <p className="text-[15px] text-ink-dim leading-relaxed mb-10">
            The operating layer behind every Rabbit module — data modeling, automation,
            machine learning and end-user experiences, built on one shared platform.
          </p>

          <Link
            to="/energy-os"
            className="group block bg-white rounded-xl border border-paper-border p-6 text-left hover:border-accent/40 hover:shadow-card transition-all"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-emerald-50 border border-emerald-100 flex items-center justify-center shrink-0">
                  <Zap size={18} className="text-emerald-600" />
                </div>
                <div>
                  <p className="text-[15px] font-semibold text-ink">EnergyOS</p>
                  <p className="text-sm text-ink-dim">
                    The AI operating system for your home's energy
                  </p>
                </div>
              </div>
              <ArrowRight size={16} className="text-ink-dim/60 group-hover:text-accent group-hover:translate-x-0.5 transition-all shrink-0" />
            </div>
          </Link>

          <p className="text-sm text-ink-dim/80 mt-8">
            Already have a Rabbit account?{' '}
            <Link to="/login" className="text-accent font-medium hover:text-accent-hover transition-colors">
              Sign in
            </Link>
          </p>
        </div>
      </main>
    </div>
  )
}
